window.cpap.onDocumentReady(() => {
  // 🚨 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  window.scheduler.postTask(
    () => {
      document.querySelectorAll('.product-form__input .form__label').forEach((node) => {
        node.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          event.currentTarget.classList.toggle('is-active');
          event.currentTarget.parentNode
            .querySelector('.options-wrap')
            ?.classList.toggle('options-wrap--expanded');
        });
      });
    },
    { priority: 'user-blocking' }
  );
});
